module.exports = __webpack_public_path__ + "static/media/sheet.4eca5490.svg";